import styles from "./styles.module.scss";

export const Projects = ({ title, buttonText, buttonUrl = "#", projects = [], className = "" }) => {
  const isWhiteOverlay = className.includes('bg-white-overlay');

  const wrapperStyles = isWhiteOverlay ? {
    background: 'white'
  } : {};

  const titleStyles = isWhiteOverlay ? {
    color: 'black'
  } : {};

  const buttonStyles = isWhiteOverlay ? {
    background: 'black',
    color: 'white',
    border: '1px solid black'
  } : {};

  return (
    <section className={`${styles.wrapper} ${className}`} style={wrapperStyles}>
      <img className={styles.bgDecoration} src={`/images/decorations/projects_decoration.svg`}></img>
      <div className={styles.container}>
        <div className={styles.header}>
          <h2 className={styles.title} style={titleStyles} data-sourceflow-prop="title" dangerouslySetInnerHTML={{ __html: title }} />
          <a className={styles.button} href={buttonUrl} style={buttonStyles} data-sourceflow-prop="buttonUrl" aria-label={buttonText}>
            <span data-sourceflow-prop="buttonText">{buttonText}</span>
          </a>
        </div>

        <div className={styles.grid}>
          {projects.map((project, i) => (
            <a
              key={i}
              href={project.link || "#"}
              className={styles.card}
              style={{ backgroundImage: `url(${project.image?.url})` }}
              data-sourceflow-prop="projects"
            >
              <div className={styles.cardInner}>
                <div className={styles.projectName}>{project.name}</div>
                <div className={styles.icon}>
                  <svg xmlns="http://www.w3.org/2000/svg" width="21" height="20" viewBox="0 0 21 20" fill="none">
                    <path
                      d="M10.3333 0C9.73617 0 9.25217 0.484027 9.25217 1.08108V8.91895H1.41433C0.817279 8.91895 0.333252 9.40295 0.333252 10C0.333252 10.5971 0.817279 11.0811 1.41433 11.0811H9.25217V18.9189C9.25217 19.516 9.73617 20 10.3333 20C10.9303 20 11.4143 19.516 11.4143 18.9189V11.0811H19.2522C19.8492 11.0811 20.3333 10.5971 20.3333 10C20.3333 9.40295 19.8492 8.91895 19.2522 8.91895H11.4143V1.08108C11.4143 0.484027 10.9303 0 10.3333 0Z"
                      fill="white"
                    />
                  </svg>
                </div>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Projects;